module.exports = __webpack_public_path__ + "static/img/areaA-13.572d728.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-13.png
// module id = 924
// module chunks = 1